import { Link } from "react-router-dom";
import { URLS } from "../_config";

interface ContentUnavailableProps {
    label: string;
    message?: string;
}

const ContentUnavailable = ({ label, message }: ContentUnavailableProps) => {
    return (
        // <div className="subscription">
            <div className="text-center my-5">
                {/* <h2>{label} not found</h2> */}
                <p>{message ?? "The content you're looking for is unavailable."}</p>
                {/* <Link to={URLS.HOME} className="master-orng-btn">Return home</Link> */}
            </div>
        // </div>
    );
}

export default ContentUnavailable;
